var snipeBannerComponent = function ($) {
    var banner;
    var defaultBanner;
    var expandedBanner;
    var cookieName;
    var cookieExpireInHours;
    var closeDefaultBtn;
    var closeExpandedBtn;
    var stickyHeader;
    var header;
    var touchTrigger;
    var crisisTrigger;
    var searchTrigger;
    var searchWrapper;
    var crisisWrapper;
    var touchNav;
    var expander;
    var settings = {
        onCompleteAnimation: null
    };

    function closeBanner(event) {
        event.preventDefault();
        setCookie(cookieName, 'served', cookieExpireInHours, '.americares.org');
        banner.removeClass('active');
        banner.slideUp('400', settings.onCompleteAnimation);
    }

    function toggleIfActive(activate) {
        if (banner.hasClass('active')) {
            if (activate) {
                showBanner(); 
            } else {
                hideBanner();
            }
        }
    }

    function hideBanner() {
        banner.slideUp('400', settings.onCompleteAnimation);
    }

    function showBanner() {
        banner.slideDown('400', settings.onCompleteAnimation);
    }

    function hideExpandedBanner(event) {
        event.preventDefault();
        banner.removeClass('is-expanded');
        expandedBanner.slideUp('400', settings.onCompleteAnimation);
        closeDefaultBtn.fadeIn();
    }

    function showExpandedBanner(event) {
        event.preventDefault();

        if (banner.hasClass('is-expanded')) return;

        banner.addClass('is-expanded');
        expandedBanner.slideDown('400', settings.onCompleteAnimation);
    }

    function setCookie(name, value, hours, domain, path) {
        var date;
        var expires = '';
        var cookieString = '';
        var cookiePath = path || '/';

        date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        expires = date.toGMTString();

        cookieString = name + '=' + value + ';';
        cookieString += ' expires=' + expires + ';';
        if (domain) {
            cookieString += ' domain=' + domain + ';';
        }
        cookieString += ' path=' + cookiePath + ';';
        document.cookie = cookieString;
    }

    function bindEvents() {
        closeDefaultBtn.on('click touchend', closeBanner);
        closeExpandedBtn.on('click touchend', hideExpandedBanner);
        expander.on('click touchend', showExpandedBanner);

        /**
         * Hide the snipe banner when viewing the search,
         * but show it again once you close the search
         */
        searchTrigger.on('click touchend', function() {
            if (searchWrapper.hasClass('search-toggle')) {
                toggleIfActive(false);
            } else {
                toggleIfActive(true);
            }
        });

        /**
         * Hide the snipe banner when viewing the menu on mobile,
         * but show it again once you close the menu
         */
        touchTrigger.on('click touchend', function() {
            if (touchNav.hasClass('active')) {
                toggleIfActive(false);
            } else {
                toggleIfActive(true);
            }
        });
    }

    function init(options) {
        banner = $('.snipe-banner');

        if (
            banner.length === 0 ||
            (banner.attr('class').indexOf('hidden-xs') >= 0 && $(window).width() < 768) ||
            (banner.attr('class').indexOf('hidden-md-and-below') >= 0 && $(window).width() < 1024)
        ) return;

        settings = Object.assign(settings, options);
        defaultBanner = banner.find('.snipe-banner__default');
        expandedBanner = banner.find('.snipe-banner__expanded');
        cookieName = banner.attr('data-cookie-name');
        cookieExpireInHours = banner.attr('data-cookie-expire');
        closeDefaultBtn = banner.find('.js-close-default');
        closeExpandedBtn = banner.find('.js-close-expanded');
        expander = banner.find('.expander');

        // header elements
        header = $('.header');
        crisisTrigger = header.find('.nav-alert__button');
        searchTrigger = header.find('.nav-search__button');
        touchTrigger = header.find('.header-mobile__trigger');
        searchWrapper = header.find('.nav-search');
        crisisWrapper = header.find('.nav-alert');
        touchNav = header.find('.touch-nav');

        bindEvents();
    }

    return {
        init: init
    };
}(jQuery);

module.exports = snipeBannerComponent;
